import store from "../store";
export var globalSelectedApp;
store.dispatch("applications/loadEntities").then(() => {
  globalSelectedApp = store.get("applications/entities")[0] || null;
});

export function isFirstInList(item, list, entities) {
  switch (list) {
    case "applications":
      var applications = store.get("applications/entities");
      return applications[0].id == item;
    case "channels":
      var channels = store.get("channels/entities");
      return channels[0].id == item;
    case "webhooks":
      // "entities" was added during conversion in UI to include default channel hooks on Application page as it was impossible to return the proper value without including an extra parameter
      return entities.length ? entities[0].id == item : false;
  }
}
export function changeSelectedApp(newApp) {
  globalSelectedApp = newApp;
}
